import {
  getNumberInputTheme,
  smallNumberInputTheme,
} from '../NumberInput/theme';
import { NumberInputTheme } from '../NumberInput/types';
import { getDefaultSliderTheme } from '../Slider/theme';
import { SliderInputTheme } from '../Slider/types';

export const getDefaultSliderInputTheme = (): SliderInputTheme &
  NumberInputTheme => ({
  ...getDefaultSliderTheme(true),
  ...getNumberInputTheme(true),
  ...smallNumberInputTheme,
});
